import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { LinkMenu } from '../../../components';
import { changeStep as changeStepAction } from '../actions/steps';
import { getCurrentStep, getOptions } from '../selectors/steps';

const EnterpriseBuilderSidebar = ({ currentStep, changeStep, options }: $TSFixMe) => (
    <LinkMenu nameKey={TextKey.StepPlural} handleNavigation={changeStep} options={options} selected={currentStep} />
);

export default connect(
    createStructuredSelector({
        currentStep: getCurrentStep,
        options: getOptions,
    }),
    { changeStep: changeStepAction }
)(EnterpriseBuilderSidebar);
